import config from '@app/config'
import { createInstance } from '@app/services/api/createInstance'
import { getBacktrack, sendEventSwitchToB2C } from '@app/utils'
import { isPowersiteReferrer } from '@app/utils/backtrack/patterns'

type ClientSwitchCodeResponse = {
  statusCode: number
  result?: {
    code?: string
  }
}

const getSwitchCulture = () => {
  return (
    config.regionalSettings?.culture ||
    config.regionalSettings?.language ||
    navigator.language ||
    'en'
  )
}

export const switchToHomeScreen = async () => {
  const b2cClientId = config.variables.b2c_clientId
  const switchBaseUrl = (
    config.variables.properstarLink ||
    config.identity.website ||
    '/'
  ).replace(/\/+$/, '')

  if (config.identity.isWebView) {
    sendEventSwitchToB2C()
    return
  }

  if (!config.identity.identityUrl) {
    window.location.assign(config.identity.website || '/')
    return
  }

  if (!b2cClientId) {
    window.location.assign(config.identity.website || '/')
    return
  }

  try {
    const idApi = createInstance({ baseURL: config.identity.identityUrl })
    const { data } = await idApi.get<ClientSwitchCodeResponse>(
      '/api/users/clientswitchCode',
      {
        params: {
          targetClientId: b2cClientId,
        },
      }
    )

    const code = data?.statusCode === 200 ? data.result?.code : null
    if (!code) {
      window.location.assign(config.identity.website || '/')
      return
    }

    const referrer = getBacktrack()
    if (referrer && isPowersiteReferrer(referrer)) {
      const referrerUrl = new URL(referrer)
      const switchUrl = new URL('/auth/switch', referrerUrl.origin)
      switchUrl.searchParams.set('code', code)
      window.location.assign(switchUrl.toString())
      return
    }

    const culture = getSwitchCulture()
    window.location.assign(
      `${switchBaseUrl}/auth/switch?code=${encodeURIComponent(code)}&culture=${encodeURIComponent(culture)}`
    )
  } catch (error) {
    console.error('Failed to switch to home screen', error)
    window.location.assign(config.identity.website || '/')
  }
}
